import classnames from 'classnames';

// Six dots, and the stylesheet knows it: .sk-chase-dot:nth-child(1..6) staggers their
// animation, so the count is structural rather than decorative.
const CHASE_DOTS = [1, 2, 3, 4, 5, 6];

// The app's one spinner, so that "we are waiting" looks the same wherever it is said.
// App draws it as the full-page overlay it has always been (.root-container.app-loading
// styles it so); security/Authenticated draws it inside the protected route it is
// holding while the app works out who the visitor is - the same wait, no longer a white
// sheet over the whole site.
export default function AppSpinner({ className }) {
  return (
    <div className={classnames('app-loader', className)}>
      <div className="sk-chase">
        {CHASE_DOTS.map((dot) => (
          <div className="sk-chase-dot" key={dot} />
        ))}
      </div>
    </div>
  );
}
